import(/* webpackMode: "eager", webpackExports: ["LoadingPageTemplate"] */ "/codebuild/output/src1263668154/src/wello-client/packages/wello/src/components/client/Templates/LoadingPageTemplate.tsx");
